export default __webpack_public_path__ + "static/IoTAndSmartCommunities-9a551f9242e934bd3be3fe4ac0dd6537.jpg";